import { initializeApp } from 'firebase/app';
import { OAuthProvider } from "firebase/auth";
import {
  getAuth,
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  sendPasswordResetEmail,
  onAuthStateChanged,
  signInWithPopup,
  GoogleAuthProvider
} from 'firebase/auth';

// Use environment variables for Firebase configuration
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID
};

// Initialize the Microsoft auth provider
const microsoftProvider = new OAuthProvider('microsoft.com');
microsoftProvider.setCustomParameters({
  prompt: 'select_account',
  tenant: 'common' // Use 'common' for any Microsoft account, or your tenant ID for specific organization
});

// Initialize the Google auth provider
const googleProvider = new GoogleAuthProvider();

// Microsoft sign-in function
export const signInWithMicrosoft = async () => {
  return signInWithPopup(auth, microsoftProvider);
};

// Google sign-in function
export const signInWithGoogle = async () => {
  return signInWithPopup(auth, googleProvider);
};


// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);

// Firebase Auth functions
export const signUpWithEmail = async (email, password) => {
  console.log(email)
  try {
    const userCredential = await createUserWithEmailAndPassword(auth, email, password);
    return userCredential;
  } catch (error) {
    console.error("Firebase signup error:", error);
    throw error;
  }
};
const validateEmail = (email) => {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
};


export const signInWithEmail = async (email, password) => {
  if (!validateEmail(email)) {
    throw new Error('Please enter a valid email address');
  }
  try {
    const userCredential = await signInWithEmailAndPassword(auth, email, password);
    // Firebase automatically includes the ID token in userCredential.user
    return userCredential;
  } catch (error) {
    // User-friendly error messages
    let errorMessage;
    switch (error.code) {
      case 'auth/user-not-found':
        errorMessage = 'No account found with this email.';
        break;
      case 'auth/wrong-password':
        errorMessage = 'Incorrect password.';
        break;
      default:
        errorMessage = 'Login failed. Please try again.';
    }
    throw new Error(errorMessage);
  }
};
export const resetPassword = async (email) => {
  try {
    await sendPasswordResetEmail(auth, email);
  } catch (error) {
    console.error("Firebase password reset error:", error);
    throw error;
  }
};

export const getCurrentUserToken = async () => {
  try {
    const user = auth.currentUser;
    if (user) {
      return await user.getIdToken(true);
    }
    return null;
  } catch (error) {
    console.error("Firebase token retrieval error:", error);
    throw error;
  }
};

export const onAuthStateChange = (callback) => {
  return onAuthStateChanged(auth, callback);
};

export const getCurrentUser = () => {
  return auth.currentUser;
};

export { auth };